var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isEdit)?_c('Banner',{attrs:{"color":"info"}},[_vm._v("\n    "+_vm._s(_vm.t('cluster.memberRoles.removeMessage'))+"\n  ")]):_vm._e(),_vm._v(" "),_c('ClusterMembershipEditor',{attrs:{"mode":_vm.mode,"parent-id":_vm.value.mgmt ? _vm.value.mgmt.id : null},on:{"membership-update":_vm.onMembershipUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }